import styled from "styled-components";
import { breakpoints, colors } from "../../styles";
import { TagContainer } from "../Tag/styles";


export const BannerHero = styled.div`
    position: relative;
    display: block;
    height: 480px;
    width:100%;

    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;

    padding-top: 16px;

    @media (max-width: ${breakpoints.tablet}) {
        background-size: cover;
    }

    &::after {
        position: absolute;
        background-color: #000;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        content: '';
        opacity: 0.55;
    }

    ${TagContainer} {
        margin-right: 8px;
    }

    .container {
        z-index: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
    }
`;

export const Infos = styled.div`
    padding: 16px;
    background-color: ${colors.background};
    max-width: 290px;
    font-weight: bold;
    border-radius: 8px;

    h2 {
        font-size: 32px;
    }

    p {
        font-size: 18px;
        margin: 16px 0;
    }

    span {
        display: block;
        text-decoration: line-through;
    }
`
